import ModalDrag from '@/pages/components/ModaDrag/ModalDrag'
import {
  Button,
  Col,
  Pagination,
  Row,
  Table,
  Tabs,
  Tooltip,
  message,
} from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import styles from './add-stu-modal.module.less'
import idataCodingStyles from '@/pages/common/global-styles/idatacoding.module.less'
import SearchInput from '@/pages/components/SearchInput/SearchInput'
import Progress from 'antd/es/progress'
import Dragger from 'antd/lib/upload/Dragger'
import Cookies from 'js-cookie'
import type { UploadProps } from 'antd'
import * as contants from '@/constants/constants'

import { download } from '@/pages/common/utils/util'
import { sendHttpPostRequest } from '@/api/http-request'
import { DownloadOutlined } from '@ant-design/icons'


interface AddStuModalProps {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  theme: string
  onCancel: () => void
  college_id?: any
  classroom_id?: any
  project_id: any
  actionCallback: () => void
}

export const AddStudentModal = (props: AddStuModalProps) => {
  const {
    open,
    setOpen,
    theme,
    onCancel,
    college_id,
    classroom_id,
    project_id,
    actionCallback,
  } = props
  const page = useRef(1)
  const pageSize = useRef(10)
  const query = useRef('')
  const [total, setTotal] = useState(0)
  const [collegeStuList, setCollegeStuList] = useState()
  const [tabActivekey, setTabActivekey] = useState('1')
  const [isUploading, setIsUploading] = useState(false)
  const [uploadName, setUploadName] = useState('')
  const [uploadStatus, setUploadStatus] = useState('') // ? uploading done error
  const [uploadPercent, setUploadPercent] = useState<any>(0)

  const [readFileStatus, setReadFileStatus] = useState('') // ? reading done error
  const [readFilePercent, setReadFilePercent] = useState(0)

  const [createUsersStatus, setCreateUsersStatus] = useState('') // ? creating done error
  const [createUsersPercent, setCreateUsersPercent] = useState(0)
  const [fileList, setFileList] = useState([] as any)
  const [filePath, setFilePath] = useState<any>('')
  const [errorMessage, setErrorMessage] = useState('')
  const [selectRowKeys, setSelectRowKeys] = useState([] as any)

  useEffect(() => {
    if (tabActivekey == '1') {
      getCollegeStuList()
    }
    return () => { }
  }, [])

  const getCollegeStuList = () => {
    let data = {
      page: page.current,
      page_size: pageSize.current,
      query: query.current,
      college_id: college_id,
      classroom_id: classroom_id,
    }
    sendHttpPostRequest('college/api/user_query_college_user', data, (res) => {
      if (res.code == 0) {
        setCollegeStuList(res.query_list)
        setTotal(res.page_info.total_count)
      } else {
        message.error(res.message)
      }
    })
  }

  // 添加用户到班级

  const addUserToClass = (user_id_list: any) => {
    console.log(JSON.stringify(user_id_list))

    let data = {
      user_id_list: JSON.stringify(user_id_list),
      classroom_id: classroom_id,
      project_id: project_id,
    }

    sendHttpPostRequest(
      'classroom/api/user_add_classroom_student',
      data,
      (res: any) => {
        if (res.code == 0) {
          message.success('添加成功')
          getCollegeStuList()
          actionCallback && actionCallback()
        } else {
          message.error(res.msg)
          // throw Error(res.msg)
        }
      }
    )
  }

  // ! 创建用户
  const createUsers = (file_path: any) => {
    setCreateUsersStatus('creating')
    let timeout = setTimeout(() => {
      setCreateUsersPercent(createUsersPercent + 10)
      if (readFilePercent < 100) {
        // 如果还需要继续执行，重新设置定时器
        timeout = setTimeout(() => {
          setCreateUsersPercent(createUsersPercent + 10)
        }, 500)
      }
    }, 500)
    // 取消定时器
    clearTimeout(timeout)
    let data = {
      file_path: file_path,
      classroom_id: classroom_id,
      project_id: project_id,
    }
    sendHttpPostRequest(
      'classroom/api/batch_import_users_by_file_path',
      data,
      (res) => {
        if (res.code == 0) {
          setCreateUsersStatus('done')
          setCreateUsersPercent(100)
        } else if (res.code == -2) {
          setCreateUsersStatus('error')
          setFilePath(res.data.feedback_file_path)
          setErrorMessage(res.msg)
        } else {
          setCreateUsersStatus('error')
          setErrorMessage(res.msg)
        }
      }
    )
    // OAMBatchCreateUserApi(data).then((res: any) => {
    //   if (res.code == 0) {
    //     setCreateUsersStatus('done')
    //     setCreateUsersPercent(100)
    //   } else if (res.code == -2) {
    //     setCreateUsersStatus('error')
    //     setFilePath(res.feedback_file_path)
    //     setErrorMessage(res.message)
    //   } else {
    //     setCreateUsersStatus('error')
    //     setErrorMessage(res.message)
    //   }
    // })
  }
  // ! 读取文件
  const readingFile = (file_path: any) => {
    let data = {
      file_path: file_path,
    }

    setReadFileStatus('reading')
    let timeout = setTimeout(() => {
      setReadFilePercent(readFilePercent + 20)
      if (readFilePercent < 100) {
        // 如果还需要继续执行，重新设置定时器
        timeout = setTimeout(() => {
          setReadFilePercent(readFilePercent + 20)
        }, 500)
      }
    }, 500)
    // 取消定时器
    clearTimeout(timeout)

    try {
      sendHttpPostRequest(
        'classroom/api/check_batch_import_users_file',
        data,
        (res) => {
          if (res.code == 0) {
            setReadFileStatus('done')
            setReadFilePercent(100)
            createUsers(file_path)
            // TODO: 下一步创建用户
          } else if (res.code == -2) {
            setReadFileStatus('error')
            setFilePath(res.data.feedback_file_path)
            setErrorMessage(res.msg)
          } else {
            setReadFileStatus('error')
            setErrorMessage(res.msg)
          }
        }
      )
      // OAMCheckUserBatchImportFileApi(data)
      //   .then((res: any) => {
      //
      //   })
      //   .catch((e) => {
      //     setReadFileStatus('error')
      //     message.error(e)
      //   })
    } catch (error) {
      setReadFileStatus('error')
    }
  }

  const uploadData = {
    sessionid: Cookies.get('sessionid'),
    sid: Cookies.get('sessionid'),
  }
  const uploadProps: UploadProps = {
    name: 'users_file',
    multiple: false,
    showUploadList: false,
    data: uploadData,
    accept: '.xlsx,.xls',
    fileList: fileList,
    action:
      contants.BACKEND_URL + '/classroom/api/batch_import_users_upload_file',
    onChange(info) {
      const { status, percent, name } = info.file

      setFileList(info.fileList)
      if (status !== 'uploading') {
      }
      if (status == 'uploading') {
        setIsUploading(true)
        setUploadPercent(percent?.toFixed())
        setUploadName(name)
        setUploadStatus(status)
      }
      if (status === 'done') {
        if (info.file.response.code == 0) {
          message.success(`${info.file.name} 文件上传成功`)
          setUploadStatus(status)
          console.log(info)

          readingFile(info.file.response.data.file_path)
        }
      } else if (status === 'error') {
        setUploadStatus(status)
        message.error(`${info.file.name} 文件上传失败`)
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files)
    },
  }

  const downloadTemplate = () => {
    sendHttpPostRequest(
      'classroom/api/download_batch_import_users_template_xlsx_file',
      {},
      (res) => {
        download(res, 'application/excel;chartset=UTF-8', '用户模板.xlsx')
      },
      { responseType: 'blob' }
    )
  }

  const onModalPageChange = (npage, npageSize) => {
    page.current = npage
    pageSize.current = npageSize
    getCollegeStuList()
    // 请求数据
  }

  const importStuSingle = (r) => {
    addUserToClass([r.user_id])
    setOpen(false)
  }

  const ActionRender = (t, r, i) => (
    <Row align={'middle'} justify={'center'}>
      <Tooltip title={'添加'} placement="top">
        <Col onClick={importStuSingle.bind(this, r)}>
          <div>
            <span className="iconfont icon-add"></span>
          </div>
        </Col>
      </Tooltip>
    </Row>
  )

  const retryToUpload = () => {
    // TODO: 重新上传
    setFileList([])
    setUploadStatus('')
    setReadFileStatus('')
    setCreateUsersStatus('')
    setReadFilePercent(0)
    setUploadPercent(0)
    setCreateUsersPercent(0)
    setIsUploading(false)
    setFilePath('')
  }

  const stuCols: any = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      render: (t, r, i) => pageSize.current * (page.current - 1) + i + 1,
      width: '80px',
      fixed: 'left',
    },
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      width: '180px',
      render: (t, r, i) => r.real_name || r.name,
    },
    {
      title: '学号/工号',
      dataIndex: 'number',
      key: 'number',
      width: '180px',
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      key: 'phone',
      width: '130px',
    },
    {
      title: '角色',
      dataIndex: 'role',
      key: 'role',
      width: '80px',
    },
    {
      title: '注册时间',
      dataIndex: 'register_time',
      key: 'register_time',
      width: '180px',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      fixed: 'right',
      width: '80px',
      render: ActionRender,
    },
  ]

  const addStuModalContent = (
    <div className={styles.tabs} style={{ position: 'relative' }}>
      <Tabs
        activeKey={tabActivekey}
        onChange={(key) => {
          setTabActivekey(key)
        }}
      >
        <Tabs.TabPane tab="从机构添加" key="1">
          <Row align={"middle"} justify={"end"} style={{ marginBottom: "10px" }}>
            <Col>
              <SearchInput
                width={224}
                onSearch={() => {
                  getCollegeStuList()
                }}
                placeholder="请输入姓名/手机号"
                onChange={(e) => {
                  query.current = e.target.value
                }}
                theme="light"
              /></Col>
          </Row>

          <div className={idataCodingStyles.tableWrapper}> 
            <Table
              scroll={{ x: 670 }}
              pagination={false}
              columns={stuCols}
              dataSource={collegeStuList}
              rowSelection={{
                onChange: (selectedRowKeys, selectedRows) => {
                  console.log(selectedRowKeys)

                  setSelectRowKeys(selectedRowKeys)
                },
              }}
              rowKey={(record) => record.user_id}
            />
          </div>
        </Tabs.TabPane>
        <Tabs.TabPane tab="从本地导入" key="2">
          <div className={styles.modalContain}>
            <div className={styles.uploadContain}>
              <div className={styles.progressContain} hidden={!isUploading}>
                <Row
                  align={'middle'}
                  justify={'space-between'}
                  style={{
                    height: '44px',
                    borderBottom: '1px solid #e5e7eb',
                    marginBottom: '12px',
                    color: '#6b7280',
                    fontSize: 13,
                    fontWeight: 500,
                  }}
                >
                  <Col>文件名</Col>
                  <Col>状态</Col>
                </Row>
                <div className={styles.progress}>
                  {/* TODO: 上传文件 */}
                  <div>
                    {' '}
                    <Row
                      style={{ width: '100%', gap: '10px' }}
                      align={'middle'}
                    >
                      <Col>
                        <span
                          style={{ color: '#4285F4', fontSize: '22px' }}
                          className={'iconfont icon_xuhao1'}
                        ></span>
                      </Col>
                      <Col>上传文件</Col>
                    </Row>
                    <Row
                      align={'middle'}
                      justify={'space-between'}
                      style={{ height: '40px', width: '592px' }}
                    >
                      <Col>{uploadName}</Col>
                      <Col className={styles.ColFlex}>
                        <div
                          className={
                            uploadStatus == 'done'
                              ? styles.uploadComplete
                              : uploadStatus == 'error'
                                ? styles.uploadError
                                : ''
                          }
                        ></div>
                        {uploadStatus == 'uploading' && (
                          <span
                            style={{ color: '#4285F4' }}
                            className="iconfont icon_zhengzaitingzhi"
                          ></span>
                        )}
                        <span>
                          {uploadStatus == 'uploading'
                            ? '上传中'
                            : uploadStatus == 'done'
                              ? '上传成功'
                              : uploadStatus == 'error'
                                ? '上传失败'
                                : ''}
                        </span>
                      </Col>
                    </Row>
                    <Progress
                      showInfo={false}
                      percent={uploadPercent}
                      status={'active'}
                      strokeColor={'#6366f1'}
                    />
                  </div>
                  {/* TODO: 读取文件 */}
                  <div>
      
                    <Row
                      style={{ width: '100%', gap: '10px' }}
                      align={'middle'}
                    >
                      <Col>
                        <span
                          style={{ color: '#4285F4', fontSize: '22px' }}
                          className={'iconfont icon_xuhao2'}
                        ></span>
                      </Col>
                      <Col>读取文件</Col>
                    </Row>
                    <Row
                      align={'middle'}
                      justify={'space-between'}
                      style={{ height: '40px', width: '592px' }}
                    >
                      <Col>{uploadName}</Col>
                      <Col className={styles.ColFlex}>
                        <div
                          className={
                            readFileStatus == 'done'
                              ? styles.uploadComplete
                              : readFileStatus == 'error'
                                ? styles.uploadError
                                : ''
                          }
                        ></div>
                        {readFileStatus == 'reading' && (
                          <span
                            style={{ color: '#4285F4' }}
                            className="iconfont icon_zhengzaitingzhi"
                          ></span>
                        )}
                        <span>
                          {readFileStatus == 'reading'
                            ? '读取中'
                            : readFileStatus == 'done'
                              ? '读取成功'
                              : readFileStatus == 'error'
                                ? '读取失败'
                                : ''}
                        </span>
                      </Col>
                    </Row>
                    <Progress
                      showInfo={false}
                      percent={readFilePercent}
                      status={'active'}
                      strokeColor={'#6366f1'}
                    />
                  </div>
        
                  <div>
                    {' '}
                    <Row
                      style={{ width: '100%', gap: '10px' }}
                      align={'middle'}
                    >
                      <Col>
                        <span
                          style={{ color: '#4285F4', fontSize: '22px' }}
                          className={'iconfont icon_xuhao3'}
                        ></span>
                      </Col>
                      <Col>创建用户</Col>
                    </Row>
                    <Row
                      align={'middle'}
                      justify={'space-between'}
                      style={{ height: '40px', width: '592px' }}
                    >
                      <Col>{uploadName}</Col>
                      <Col className={styles.ColFlex}>
                        <div
                          className={
                            createUsersStatus == 'done'
                              ? styles.uploadComplete
                              : createUsersStatus == 'error'
                                ? styles.uploadError
                                : ''
                          }
                        ></div>
                        {createUsersStatus == 'creating' && (
                          <span
                            style={{ color: '#4285F4' }}
                            className="iconfont icon_zhengzaitingzhi"
                          ></span>
                        )}
                        <span>
                          {createUsersStatus == 'creating'
                            ? '创建中'
                            : createUsersStatus == 'done'
                              ? '创建成功'
                              : createUsersStatus == 'error'
                                ? '创建失败'
                                : ''}
                        </span>
                      </Col>
                    </Row>
                    <Progress
                      showInfo={false}
                      percent={createUsersPercent}
                      status={'active'}
                      strokeColor={'#6366f1'}
                    />
                  </div>
                </div>
              </div>

              <div hidden={isUploading} style={{ height: '400px' }}>
                <Dragger {...uploadProps}>
                  <h2 className={styles.importTitle}>
                    导入之前，请先
                    <a
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        downloadTemplate()
                      }}
                      type="link"
                      style={{ fontSize: '18px', padding: 0, color: '#4f46e5' }}
                    >
                      下载模版
                    </a>
                    ～
                  </h2>

                  <Button style={{ marginTop: 80, borderRadius: 999, padding: '0 28px', height: 36, background: 'linear-gradient(135deg, #6366f1, #4f46e5)', border: 'none', boxShadow: '0 2px 6px rgba(99,102,241,0.3)' }} type="primary">
                    点击上传
                  </Button>
                  <h2>或将文件拖到此处</h2>
                  <div className={styles.tip}>
                    已注册用户请从平台添加，本地导入将会自动为未注册的用户创建账号，默认密码
                    <span className={styles.highlight}>123456</span>
                  </div>
                  <span className={styles.tip}>
                    只能上传xls/xlsx
                    文件，工作项数量限制3000条，数据文件大小限制为10M
                  </span>
                </Dragger>
              </div>
            </div>
            {(uploadStatus == 'error' ||
              readFileStatus == 'error' ||
              createUsersStatus == 'error') && (
                <Row
                  align={'middle'}
                  justify={'space-between'}
                  style={{ width: '100%', padding: '20px 34px' }}
                >
                  <Col className={styles.errorTip}>
                    <span className="iconfont icon-shibai1"></span>
                    {errorMessage}
                  </Col>
                  {filePath && (
                    <Col>
                      <div
                        className={styles.btnBox}
                        onClick={() => {
                          let data = {
                            sessionid: Cookies.get('sessionid'),
                            file_path: filePath,
                          }

                          sendHttpPostRequest(
                            'classroom/api/download_batch_import_users_feedback_files',
                            data,
                            (res) => {
                              download(
                                res,
                                'application/excel;chartset=UTF-8',
                                (readFileStatus == 'error' ? '读取' : '创建') +
                                '错误反馈数据.xlsx'
                              )
                            },
                            { responseType: 'blob' }
                          )
                        }}
                      >
                        <DownloadOutlined style={{ color: '#999' }} />
                      </div>
                    </Col>
                  )}
                </Row>
              )}
          </div>
        </Tabs.TabPane>
      </Tabs>
    </div>
  )
  return (
    <ModalDrag
      width={720}
      modalTitle={'添加学生'}
      modalContent={addStuModalContent}
      open={open}
      theme={theme}
      onCancel={() => {
        retryToUpload()
        setOpen(false)
      }}
      footer={
        <div>
          {tabActivekey == '1' ? (
            <Row align="middle" justify="space-between">
              <Col>
                <Pagination
                  current={page.current}
                  pageSize={pageSize.current}
                  onChange={onModalPageChange}
                  total={total}
                  hideOnSinglePage
                />
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    retryToUpload()
                    setOpen(false)
                  }}
                  style={{ width: 80, padding: 0, borderRadius: 999, marginRight: 10 }}
                >
                  取消
                </Button>
                <Button
                  style={{ width: 80, padding: 0, borderRadius: 999, background: 'linear-gradient(135deg, #6366f1, #4f46e5)', border: 'none', boxShadow: '0 2px 6px rgba(99,102,241,0.3)' }}
                  type="primary"
                  onClick={() => {
                    try {
                      addUserToClass(selectRowKeys)
                      setSelectRowKeys([])
                      setOpen(false)
                    } catch (e) { }
                  }}
                >
                  确定
                </Button>
              </Col>
            </Row>
          ) : uploadStatus ? (
            <Row align="middle" justify="center" style={{ gap: 12 }}>
              <Col>
                <Button
                  onClick={() => {
                    retryToUpload()
                    setOpen(false)
                  }}
                  style={{ width: 80, padding: 0, borderRadius: 999 }}
                >
                  取消
                </Button>
              </Col>
              {uploadStatus == 'done' &&
                createUsersStatus == 'done' &&
                readFileStatus == 'done' ? (
                <Col>
                  <Button
                    style={{ width: 80, padding: 0, borderRadius: 999, background: 'linear-gradient(135deg, #6366f1, #4f46e5)', border: 'none', boxShadow: '0 2px 6px rgba(99,102,241,0.3)' }}
                    type="primary"
                    onClick={() => {
                      setSelectRowKeys([])
                      setOpen(false)
                      actionCallback && actionCallback()
                    }}
                  >
                    确定
                  </Button>
                </Col>
              ) : (
                <Button
                  disabled={
                    !(
                      uploadStatus == 'error' ||
                      readFileStatus == 'error' ||
                      createUsersStatus == 'error'
                    )
                  }
                  type="primary"
                  style={{ borderRadius: 999, background: 'linear-gradient(135deg, #6366f1, #4f46e5)', border: 'none', boxShadow: '0 2px 6px rgba(99,102,241,0.3)' }}
                  onClick={retryToUpload}
                >
                  重新上传
                </Button>
              )}
            </Row>
          ) : (
            false
          )}
        </div>
      }
    />
  )
}

export default AddStudentModal
